import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-header-not-buttons',
  templateUrl: './header-not-buttons.component.html',
  styleUrls: ['./header-not-buttons.component.scss'],
})
export class HeaderNotButtonsComponent implements OnInit {
  constructor(public modalController: ModalController) {}

  ngOnInit() {}

  async closeModal() {
    await this.modalController.dismiss();
  }
}
